import AsyncStorage from '@react-native-async-storage/async-storage';

import type { HouseholdViewMode } from '../../services/householdService';

const HOUSEHOLD_VIEW_KEY = '@budget/household_view_mode';

export async function loadHouseholdViewMode(): Promise<HouseholdViewMode | null> {
  try {
    const raw = await AsyncStorage.getItem(HOUSEHOLD_VIEW_KEY);
    if (raw === 'personal' || raw === 'combined') return raw;
    return null;
  } catch {
    return null;
  }
}

export async function saveHouseholdViewMode(view: HouseholdViewMode): Promise<void> {
  try {
    await AsyncStorage.setItem(HOUSEHOLD_VIEW_KEY, view);
  } catch {
    // ignore
  }
}
